import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

// Определяем язык браузера: если русский — ставим ru, иначе — en
const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
const detectedLng = browserLang.startsWith('ru') ? 'ru' : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    lng: detectedLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
